// extracted by mini-css-extract-plugin
export var displayNone = "_ue-6";
export var imgContainer = "_ue-2";
export var overflowHidden = "_ue-3";
export var productInfoCardButtonContainer = "_ue-5";
export var productTitleText = "_ue-4";
export var rightArrow = "_ue-1";
export var rightArrowContainer = "_ue-0";